import React from "react";
import PropTypes from "prop-types";
import { parseFieldArea } from "utils";
import "./index.scss";

const TotalAreaCell = ({ value, row }) => (
  <div data-testid="total-area-cell" className="total-area-cell">
    <div className={row.isExpanded ? "cell-header" : "cell-header -hidden"}>
      Total Area
    </div>
    <div>{parseFieldArea(value)} Ha</div>
  </div>
);

TotalAreaCell.defaultProps = {
  value: 0,
};

TotalAreaCell.propTypes = {
  value: PropTypes.number,
  row: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
};

export default TotalAreaCell;
